export default {
    /* GET_REQUESTS
    ---------------------------------------------------------------
    */
    GET_REQUESTS_REQUEST: state => {
        state.requestsLoading = true
    },
    GET_REQUESTS_SUCCESS: (state, data) => {
        state.requests = data.results
        state.requestsLoading = false
    },
    GET_REQUESTS_FAILURE: state => {
        state.requestsLoading = false
    },
    /* GET_REQUEST_TYPES
    ---------------------------------------------------------------
    */
    GET_REQUEST_TYPES_SUCCESS: (state, data) => {
        state.requestTypes = data
    },
    /* GET_REQUEST_STATUSES
    ---------------------------------------------------------------
    */
    GET_REQUEST_STATUSES_SUCCESS: (state, data) => {
        state.requestStatuses = data
    },
    /* GET_REQUEST
    ---------------------------------------------------------------
    */
    GET_REQUEST_SUCCESS: (state, data) => {
        state.requestAttachments = data.attachment
        state.materials = data.materials
    },
    CLEAR_REQUEST_ATTACHMENTS: state => {
        state.requestAttachments = []
    },
    SET_REQUEST_FILTERS: (state, filters) => {
        state.filters = filters
    },
    UPDATE_MATERIALS_LIST: (state, material) => {
        state.materials.push(material)
    },
    UPDATE_MATERIAL: (state, material) => {
        state.materials.forEach(function(item) {
            if (item.id === material.id) {
                item.materialName = material.materialName,
                item.materialFormat= material.materialFormat,
                item.materialWeight= material.materialWeight,
                item.unit= material.unit,
                item.externalRequestNumber= material.externalRequestNumber,
                item.providerName= material.providerName,
                item.deliveryDate= material.deliveryDate,
                item.atStock= material.atStock
            }
        })
    },
    CLEAR_MATERIALS_LIST: state => {
        state.materials = []
    },
    CLEAR_REQUEST_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}